import { styled } from "@mui/material";
import Chip from "components/mui5/Chip";
import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface NewTagProps {
  expirationDate?: string;
}

export const NewChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.secondary1[60],
  color: theme.palette.secondary1[180],
  textTransform: "uppercase",
  borderRadius: "4px",
  padding: "2px 4px",
  height: "auto",
  fontWeight: "500",

  "& .MuiChip-label": {
    padding: "0",
    ...theme.typography.TextS,
  },
}));

function NewTag(props: NewTagProps) {
  const { expirationDate } = props;
  const { t } = useTranslation();
  const showNew = useMemo(() => {
    if (!expirationDate) return false;
    return moment().isBefore(moment(expirationDate));
  }, [expirationDate]);

  if (!showNew) return null;

  return <NewChip label={t("global.new_label_text")} />;
}

export default NewTag;
